import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import 'twin.macro';

import { Loader } from '@components/Loader';
import { UsersTable } from '@account_module/components/users-table/UsersTable';
import { RemoveUserModal } from '@account_module/components/RemoveUserModal';
import { TableDataError } from '@insights_module/components/TableDataError';

import { useAccountSettingContext } from '@account_module/context/AccountSettingsContext';
import { useOrganizations } from '@account_module/hooks/useOrganizations';
import { useOrganizationUsers } from '@account_module/hooks/useOrganizationUsers';
import { Layout } from '@insights_module/components/Layout';
import { UsersTableController } from '@account_module/components/users-table/UsersTableControler';

export const SettingsPage = () => {
  const { isLoading, getOrganizationByIndex, data } = useOrganizations();
  const organization = getOrganizationByIndex(0);
  const { isLoading: isUsersLoading } = useOrganizationUsers(organization?.id);
  const { isRemoveUserModalActive, setCurrentOrganization } = useAccountSettingContext();

  useEffect(() => {
    if (organization) {
      setCurrentOrganization(organization.id);
    }
  }, [organization]);

  if (isLoading || isUsersLoading) {
    return (
      <Layout.Background>
        <Loader size='lg' theme='dark' />
      </Layout.Background>
    );
  }

  if (!data?.length) {
    return (
      <>
        <TableDataError />
        <span tw='block text-center my-2 text-muted2'>or</span>
        <Link to='/insights' tw='block w-full text-center'>
          Go back
        </Link>
      </>
    );
  }

  return (
    <>
      <div>
        <Layout.InsightsPage>
          <UsersTableController />
          <UsersTable />
        </Layout.InsightsPage>

        {isRemoveUserModalActive && <RemoveUserModal />}
      </div>
    </>
  );
};
